<div class="contenedor_dialogo">
  @if (!Modal.hiddenTitle) {
    <header class="contenedor_dialogo_cabecera" mat-dialog-title>
      <h4>{{Modal.title | titlecase}}</h4>
      @if (Modal.closeTitle) {
        <button mat-icon-button aria-label="Cierra contenedor dialogo" [mat-dialog-close]="true">
            <mat-icon>clear</mat-icon>
        </button>
      }
    </header>
  }

  <mat-dialog-content appAutoScroll class="mat-typography">
    <ng-content select="[body]"></ng-content>
  </mat-dialog-content>

  @if (!Modal.hiddenFooter) {
    <mat-dialog-actions align="end">
      <ng-content select="[footer]"></ng-content>
    </mat-dialog-actions>
  }
</div>